import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

export default function InvitedTalks() {

  const talkData = [
    { term: '2026.09', desp: <>"ProgramDistill: From Interactive Web Apps to Verifiable Reference-Guided SWE Tasks" @ <a href="https://coco-kaist.github.io/" target="_blank" rel="noopener noreferrer">KAIST COCO Lab</a></> },
    { term: '2026.06', desp: '"How Do LLMs Know They Are Wrong? Exploration and the Dual Role of Self-Distillation" @ Upstage AI', link: `${process.env.PUBLIC_URL}/slides/upstage_0626.pdf`, linkLabel: 'slides' },
    { term: '2025.02', desp: '"Adaptive Q-Aid for Conditional Supervised Learning in Offline Reinforcement Learning" @ ML2', link: 'https://www.linkedin.com/posts/kc-ml2_adaptive-q-aid-for-conditional-supervised-activity-7292383449196154880-dBwu?utm_source=share&utm_medium=member_desktop&rcm=ACoAADI0k_UBGle4TdIzFl0nzXRRDqxFZcvpEIc' },
    { term: '2023.10', desp: '"LESSON: Learning to Integrate Exploration Strategies for Reinforcement Learning via an Option Framework" @ center for applied research in artificial intelligence (CARAI)' },
  ];

  const textStyle = {
    fontSize: '0.9rem',
    color: 'grey.500',
    fontWeight: 'bold',
    width: '80px',
    flexShrink: 0,
  };

  const TalkItem = ({ term, desp, link, linkLabel }) => (
    <Box
      sx={{
        mt: term === 'Fall 2023' ? 0 : 1,
        pl: 0.5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ ...textStyle, mr: 1 }}>
        {term}
      </Typography>
      <Typography sx={{ fontSize: '1rem', mr: link ? 1 : 0 }}>
        {desp}
      </Typography>
      {link && (
        <Typography sx={{ fontSize: '1rem' }}>
          <a href={link} target="_blank" rel="noopener noreferrer">
            [{linkLabel || 'Link'}]
          </a>
        </Typography>
      )}
    </Box>
  );

  TalkItem.propTypes = {
    term: PropTypes.string.isRequired,
    desp: PropTypes.node.isRequired,
    link: PropTypes.string,
    linkLabel: PropTypes.string
  };

  return (
    <Box>
    {talkData.map((item, index) => (
      <TalkItem key={index} term={item.term} desp={item.desp} link={item.link} />
    ))}
  </Box>
  )
}